import React from "react";
import { useAuthState } from "../../../auth";
// import { PAGES } from "../../../constants/pages";
import { Button } from "../../atoms/button";
import { Flex } from "../../atoms/flex";
import "./navigation-header.css";

interface NavigationHeaderProps {
  signedIn?: boolean;
  hideNavigation?: boolean;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  signedIn = false,
  hideNavigation,
}) => {
  const { logout } = useAuthState();

  if (hideNavigation) {
    return null;
  }
  return (
    <Flex>
      <header className="Header">
        <nav className="Header-nav">
          <ul className="Header-ul">
{/*            <li className="Header-li">
              <a href={PAGES.MISSION.url}>{PAGES.MISSION.text}</a>
            </li>
            <li className="Header-li">
              <a href={PAGES.PRODUCTS.url}>{PAGES.PRODUCTS.text}</a>
            </li>*/}
          </ul>
          <img
            src="images/logo_no_text.png"
            id="company-logo"
            className="company-logo"
            alt="logo"
          />
          <ul className="Header-ul">
{/*            <li className="Header-li">
              <a href={PAGES.ABOUT_US.url}>{PAGES.ABOUT_US.text}</a>
            </li>
            <li className="Header-li">
              <a href={PAGES.MIN_SIDA.url}>{PAGES.MIN_SIDA.text}</a>
            </li>*/}
          </ul>
        </nav>
        {signedIn && (
          <Button className="Button-logout" onClick={logout}>
            Logga ut
          </Button>
        )}
      </header>
    </Flex>
  );
};
